<template>
    <v-container>
        <div>
            <template>
                <v-dialog v-model="dialog" width="876" persistent>
                    <v-card class="custom-card" rounded="0">
                        <v-toolbar color="secondary" class="white--text">
                            <v-toolbar-title class="font-weight-bold">
                                {{ parasiteControl.id ? $t("editCurrentRecord") : $t("addNewRecord") }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon class="white--text" @click="closeModal">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-toolbar class="bdr secondary2light mt-4 ml-4" style="width: 80%;" :elevation="0" outlined
                            v-if="parasiteControl.id">
                            <v-toolbar-title class="grey--text text--darken-2" style="font-size: 13px">Do you
                                really want to edit this record ? Your previous records might get affected.
                            </v-toolbar-title>
                        </v-toolbar>
                        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="addParasiteControlRecord"
                            style="padding: 20px">
                            <v-row>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.date') }}</label>
                                    <v-tooltip top color="black" max-width="350">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon v-bind="attrs" v-on="on">
                                                mdi-help-circle-outline
                                            </v-icon>
                                        </template>
                                        <span>
                                            {{ $t("animal.healthRecordInfo.treatmentDateTooltip") }}
                                        </span>
                                    </v-tooltip>
                                    <v-menu v-model="parasiteDateMenu" :close-on-content-click="false" :nudge-right="40"
                                        transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field v-model="parasiteControl.parasiteDate"
                                                append-icon="mdi-calendar" outlined dense readonly v-bind="attrs"
                                                v-on="on" v-on:click:append="parasiteDateMenu = true"
                                                placeholder="Select date"></v-text-field>
                                        </template>
                                        <v-date-picker v-model="parasiteControl.parasiteDate" placeholder="Select Date"
                                            @input="parasiteDateMenu = false"></v-date-picker>
                                    </v-menu>
                                </v-col>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.purpose') }}

                                        <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ $t('animal.healthRecordInfo.purposeTooltip') }}
                                            </span>
                                        </v-tooltip>

                                    </label>
                                    <v-select v-model="parasiteControl.purpose" :items="purposes" outlined dense
                                        placeholder="Select purpose" v-if="parasiteControl.purpose !== 'Others'">
                                    </v-select>
                                    <v-text-field v-if="parasiteControl.purpose == 'Others'" type="text" outlined dense
                                        placeholder="Purpose" @click:clear="purposeClear" clearable
                                        v-model="parasiteControl.otherPurpose"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.drugName') }}
                                        <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ $t('animal.healthRecordInfo.drugNameTooltip') }}
                                            </span>
                                        </v-tooltip>
                                    </label>
                                    <v-text-field type="text" outlined dense
                                        :placeholder="$t('animal.healthRecordInfo.drugName')"
                                        v-model="parasiteControl.parasiteDrugName"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.dose') }}
                                        <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ $t('animal.healthRecordInfo.dooseTooltip') }}
                                            </span>
                                        </v-tooltip>
                                    </label>
                                    <div class="d-flex">
                                        <v-text-field type="number" :min="0" outlined dense
                                            :placeholder="$t('animal.healthRecordInfo.dose')"
                                            oninput="this.value = Math.abs(this.value)"
                                            v-model="parasiteControl.doseRate">
                                        </v-text-field>
                                        <v-select :items="doseUnits" item-text="name" item-value="unit" outlined
                                            class="ml-4" placeholder="Unit" dense v-model="parasiteControl.doseRateUnit"
                                            v-if="parasiteControl.doseRateUnit !== 'Others'"></v-select>
                                        <v-text-field v-if="parasiteControl.doseRateUnit == 'Others'" type="text"
                                            class="ml-4" outlined dense placeholder="Unit" clearable 
                                            @click:clear="doseRateClear" v-model="parasiteControl.otherDoseRateUnit">
                                        </v-text-field>
                                    </div>

                                </v-col>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.withdrawalPeriod') }}
                                        <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ $t('animal.healthRecordInfo.withdrawTooltip') }}
                                            </span>
                                        </v-tooltip>
                                    </label>
                                    <div class="d-flex">
                                        <v-text-field type="number" :min="0" outlined dense placeholder="Enter Value"
                                            v-model="parasiteControl.withdrawalPeriod" oninput="this.value = Math.abs(this.value)"></v-text-field>
                                        <v-select :items="withdrawalPeriodUnits" item-text="text" item-value="name"
                                            outlined class="ml-4" placeholder="Select Period" dense
                                            v-model="parasiteControl.withdrawalPeriodUnit"></v-select>
                                    </div>

                                </v-col>
                                <v-col cols="6">
                                    <label class="label">{{ $t('animal.healthRecordInfo.routeOfAdministration') }}
                                        <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                                {{ $t('animal.healthRecordInfo.routeOfAdministrationTooltip') }}
                                            </span>
                                        </v-tooltip>
                                    </label>
                                    <v-select v-model="parasiteControl.routeOfAdministration"
                                        :items="routeOfAdministrations" outlined dense
                                        placeholder="Select Route of Administration"
                                        v-if="parasiteControl.routeOfAdministration !== 'Others'">
                                    </v-select>
                                    <v-text-field v-if="parasiteControl.routeOfAdministration == 'Others'" type="text"
                                        outlined dense placeholder="Route of Administration"
                                        @click:clear="routeOfAdministrationClear" clearable
                                        v-model="parasiteControl.otherRouteOfAdministration"></v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <label class="label">{{ $t('animal.healthRecordInfo.notes') }}</label> 
                                    <v-tooltip top color="black" max-width="350">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on">
                                                    mdi-help-circle-outline
                                                </v-icon>
                                            </template>
                                            <span>
                                               Notes
                                            </span>
                                        </v-tooltip>
                                    <v-text-field type="text" outlined dense
                                        placeholder="Please add additional details and notes"
                                        v-model="parasiteControl.remarks"></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider></v-divider>
                            <v-card-actions style="padding: 20px">
                                <v-spacer></v-spacer>
                                <v-btn outlined class="mr-2" right height="44" width="116" depressed color="primary"
                                    @click="closeModal">
                                    {{ $t("cancel") }}
                                </v-btn>
                                <v-btn right height="44" width="116" color="primary" type="submit">
                                    {{ parasiteControl.id ? $t("update") : $t("submit") }}
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card>
                </v-dialog>
            </template>
        </div>
    </v-container>
</template>
  
<script>
import loadingMixin from "@/mixins/LoadingMixin";
import gql from "graphql-tag";
import moment from 'moment';
import {
    doseUnits,
    withdrawalPeriodUnits
} from "@/models/units.js";

export default {
    computed: {
        dialog() {
            return this.dialogI
        },
        purposes() {
            return [
                'Deworming (Internal)',
                'External Parasite Control',
                'Extendo Parasites',
                'Others'
            ]
        },
        routeOfAdministrations() {
            return [
                'Oral',
                'Sublingual',
                'Rectal',
                'Topical',
                'Parenteral (intravenous)',
                'Intramuscular',
                'Subcutaneous',
                'Others'
            ];
        }
    },
    methods: {
        closeModal() {
            this.$emit("closeDialog");
        },
        addParasiteControlRecord() {
            if (!this.$refs.form.validate()) return;
            

            if(this.parasiteControl.doseRate == "" && 
            this.parasiteControl.doseRateUnit == "" && 
            this.parasiteControl.parasiteDate == "" && 
            this.parasiteControl.parasiteDrugName == "" && 
            this.parasiteControl.purpose == "" && 

            this.parasiteControl.remarks == "" && 
            this.parasiteControl.routeOfAdministration == "" && 
            this.parasiteControl.withdrawalPeriod == null && 
            this.parasiteControl.withdrawalPeriodUnit == "" && 

            this.parasiteControl.otherRouteOfAdministration == "" && 
            this.parasiteControl.otherDoseRateUnit == "" && 
            this.parasiteControl.otherPurpose == ""
            
            
            ) {
                this.$notify({
                        //title: `No details entered.`,
                        text: 'No details entered.',
                        type: "error",
                        position: "top right",
                    });
                return;
            }
            this.startLoading();

            const mutation = this.parasiteControl && this.parasiteControl.id
                ? `mutation ($data: UpdateParasiteControlInput!) {
            updateParasiteControl (updateParasiteControl: $data) {
              id
            }
          }`
                : `mutation ($data: CreateParasiteControlInput!) {
            createParasiteControl (createParasiteControlInput: $data) {
              id
            }
          }`;
            this.$apollo.mutate({
                mutation: gql`${mutation}`,
                variables: {
                    data: {
                        id: this.parasiteControl.id,
                        animalId: parseInt(this.$route.params.animal_number),
                        parasite_date: this.parasiteControl.parasiteDate ? moment(this.parasiteControl.parasiteDate).format('YYYY-MM-DD') : null,
                        purpose: this.parasiteControl.purpose == 'Others' ? this.parasiteControl.otherPurpose : this.parasiteControl.purpose,
                        parasite_drug_name: this.parasiteControl.parasiteDrugName,
                        dose_rate: this.parasiteControl.doseRate,
                        dose_rate_unit: this.parasiteControl.doseRateUnit == 'Others' ? this.parasiteControl.otherDoseRateUnit : this.parasiteControl.doseRateUnit,
                        withdrawal_period: parseInt(this.parasiteControl.withdrawalPeriod),
                        withdrawal_period_unit: this.parasiteControl.withdrawalPeriodUnit,
                        route_of_administration: this.parasiteControl.routeOfAdministration == 'Others' ? this.parasiteControl.otherRouteOfAdministration : this.parasiteControl.routeOfAdministration,
                        remarks: this.parasiteControl.remarks,
                    }
                }
            }).then((res) => {
                let msg = "added";

                if (this.parasiteControl.id) {
                    msg = "updated"
                }
                if (res.data) {
                    this.$notify({
                        title: `Parasite Control record ${msg} successfully`,
                        text: res.message,
                        type: "success",
                        position: "top right",
                    });

                    this.$emit('onUpdate');
                } else {
                    this.$notify({
                        title: `Parasite Control Record Not ${msg}`,
                        text: res.message,
                        type: "error",
                        position: "top right",
                    });
                }
                this.stopLoading();
                this.closeModal();
            })
                .catch((err) => {
                    console.log(err.data);
                    this.stopLoading();
                });
        },
        doseRateClear() {
            this.parasiteControl.doseRateUnit = ""
            this.parasiteControl.otherDoseRateUnit = ""
        },
        routeOfAdministrationClear() {
            this.parasiteControl.routeOfAdministration = ""
            this.parasiteControl.otherRouteOfAdministration = ""
        },
        purposeClear() {
            this.parasiteControl.otherPurpose = ""
            this.parasiteControl.purpose = ""
        }
    },
    data() {
        return {
            parasiteDateMenu:false,
            parasiteControl: {
                id: null,
                doseRate: "",
                doseRateUnit: "",
                animalId: parseInt(this.$route.params.animal_number),
                parasiteDate: "",
                parasiteDrugName: "",
                purpose: "",
                remarks: "",
                routeOfAdministration: "",
                withdrawalPeriod: null,
                withdrawalPeriodUnit: "",
                otherRouteOfAdministration: "",
                otherDoseRateUnit: "",
                otherPurpose: "",
            },
            // parasiteControlRules: {
            //     dose: [(v)=> {if (v) return v>=0  || 'Value cannot be less than 0'}],
            //     withdrawalPeriod: [(v)=> {if (v) return v>=0  || 'Value cannot be less than 0'}],
            // },
            valid: true,
            doseUnits,
            withdrawalPeriodUnits
        }
    },
    mounted() {
        if (this.parasiteControlItem) {
            this.parasiteControl.id = this.parasiteControlItem.id
            this.parasiteControl.parasiteDrugName = this.parasiteControlItem.parasiteDrugName
            this.parasiteControl.doseRate = this.parasiteControlItem.doseRate
            this.parasiteControl.doseRateUnit = doseUnits.find(x => x.unit === this.parasiteControlItem.doseRateUnit) ? this.parasiteControlItem.doseRateUnit : !this.parasiteControlItem.doseRateUnit? '' : 'Others'
            this.parasiteControl.purpose = this.purposes.includes(this.parasiteControlItem.purpose) ? this.parasiteControlItem.purpose : !this.parasiteControlItem.purpose? '' : 'Others'
            this.parasiteControl.parasiteDate = this.parasiteControlItem.parasiteDate ? moment(this.parasiteControlItem.parasiteDate).format('YYYY-MM-DD') : null
            this.parasiteControl.withdrawalPeriod = this.parasiteControlItem.withdrawalPeriod
            this.parasiteControl.withdrawalPeriodUnit = this.parasiteControlItem.withdrawalPeriodUnit
            this.parasiteControl.remarks = this.parasiteControlItem.remarks
            this.parasiteControl.routeOfAdministration = this.routeOfAdministrations.includes(this.parasiteControlItem.routeOfAdministration) ? this.parasiteControlItem.routeOfAdministration : !this.parasiteControlItem.routeOfAdministration? '' : 'Others'
            this.parasiteControl.otherRouteOfAdministration = this.routeOfAdministrations.includes(this.parasiteControlItem.routeOfAdministration) ? '' : this.parasiteControlItem.routeOfAdministration
            this.parasiteControl.otherDoseRateUnit = doseUnits.find(x => x.unit === this.parasiteControlItem.doseRateUnit) ? '' : this.parasiteControlItem.doseRateUnit
            this.parasiteControl.otherPurpose = this.purposes.includes(this.parasiteControlItem.purpose) ? '' : this.parasiteControlItem.purpose
        }
    },
    props: ["dialogI", "parasiteControlItem"],
    mixins: [loadingMixin],
};
</script>
  
<style scoped>
::v-deep .v-messages__message {
    line-height: 12px;
    word-break: break-word;
    /* overflow-wrap: break-word; */
    word-wrap: break-word;
    -webkit-hyphens: auto;
    hyphens: auto;
    white-space: nowrap;
}
</style>
   